/** Quantity arithmetic used on screen. Follows the same integer-space rules as the server's domain/quantity.ts. */
const SCALE = 1000;

export const toThousandths = (value: string): number => Math.round(Number(value) * SCALE);
export const fromThousandths = (n: number): string => (n / SCALE).toFixed(3);

/** Amount moved per ± button press. Uses the SKU's order step directly. */
export function stepQty(value: string, step: string, direction: 1 | -1): string {
  const next = toThousandths(value) + direction * toThousandths(step);
  return fromThousandths(Math.max(toThousandths(step), next));
}

/** Previews whether the string the user typed looks like it'll pass server validation (the server makes the final call). */
export function isQtyWellFormed(value: string, sku: { isDivisible: boolean; qtyStep: string }): boolean {
  if (!/^\d{1,9}(\.\d{1,3})?$/.test(value)) return false;
  const q = toThousandths(value);
  if (q <= 0) return false;
  if (!sku.isDivisible && q % SCALE !== 0) return false;
  const step = toThousandths(sku.qtyStep);
  return step <= 0 || q % step === 0;
}
